<div class="flex flex-col w-full h-full bg-grey-100">
  <!-- section one for Nom Org details-->

  <div class="w-full pb-2 bg-grey-200 page-padding-y page-padding-x">

    <div class="flex flex-row">

      <div class="mt-4 mr-6 body-xlarge-bold">
        <label for="nom-org-select">Nominating Organisation</label>
      </div>

      <div *ngIf="isUpdatingNomOrg"  class="absolute z-50 flex items-center justify-center w-full h-full bg-white opacity-50 right-2">
        <app-loading-indicator [size]="64"></app-loading-indicator>
      </div>

      <div class="w-2/6">

          <app-select
            id="nom-org-select"
            [options]="nominatingOrganizationList"
            [value]="selectedNominatingOrganization?.id"
            (valueChange)="onNomOrgSelect($event)"
          ></app-select>
      </div>
    </div>

    <div class="flex flex-row mb-2 body-default-bold">
    Organisation Details
    </div>

    <form [formGroup]="nomOrgForm">
      <div class="flex ">
        <div class="flex flex-row w-4/6 gap-5 children:w-1/3">

          <app-input formControlName="email" label="Email" placeholder="" [isReadOnly]="true"
            id="input-email"></app-input>

          <app-input formControlName="phone" label="Phone" placeholder="" [maxLength]="20"
            id="input-phone"></app-input>

          <app-input formControlName="website" label="Website" placeholder=""
            id="input-website"></app-input>

        </div>
        <div class="flex justify-end w-2/6 mt-5 text-end">

          <button id="update-nom-org-button" class="flex items-center justify-center h-10 btn body-default-regular btn-primary disabled:bg-gray-300"
            (click)="updateNomOrgDetails()" type="button" [disabled]="!isNomOrgDetailsChanged">
            <span class="mr-2 material-symbols-rounded">edit</span><span>Update</span>
          </button>

        </div>

      </div>
    </form>
  </div>

  <!-- section two -->
  <div class="flex-1 pt-6 bg-grey-100 page-padding-x page-padding-b max-w-[100vw]">
    <ng-container>
      <app-tab #appTab [tabs]="tabs" id="committeesTab" (onTabChange)="onTabChange($event)">
      </app-tab>

      <div [class.hidden]="selectedTab !== this.tabIds.committeesRepresentedOn">
        <app-nom-org-committee [loading]="loading" [committees]="committeeTableData" />
      </div>

      <div [class.hidden]="selectedTab !== this.tabIds.projects">
        <app-nom-org-project [committees]="committees"></app-nom-org-project>
      </div>

      <div [class.hidden]="selectedTab !== this.tabIds.myRepresentatives">
        <app-nom-org-representative [loading]="loading" [nominatingOrganisation]="selectedNominatingOrganization"></app-nom-org-representative>
      </div>

      <!-- <div [class.hidden]="selectedTab !== this.tabIds.declarationOfInterest">
        <p>Declaration of Interest</p>
      </div> -->
    </ng-container>
  </div>
</div>
